require('./_set-species')('Array');


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/taxpadweb/~/core-js/modules/es6.array.species.js
// module id = ../../../../core-js/modules/es6.array.species.js
// module chunks = 1